import { Component, OnInit } from '@angular/core';

import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, RequestMethod} from '@angular/http';


import { AlertService, AuthenticationService } from '../../services/index';
import { Router, ActivatedRoute } from '@angular/router';
import { Profile, Session } from '../../models/index';
import { CookieService } from 'ngx-cookie-service';


@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent {

  returnUrl: string;

  private email: string;
  private password: string;
  private isRemember: boolean;

  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private router: Router,
    private cookieService:CookieService){}
  
  ngOnInit() {
    // To-be 로그인 페이지 삭제 
    
    // this.authenticationService.session().subscribe(
    //   res =>{
    //     if(res.result){
    //       this.router.navigate(['/quotation/main']);

    //       if(res.data && res.data.token) {

    //         if(this.cookieService.get('innerToken')) {
    //           this.cookieService.delete('innerToken');
    //         };
  
    //         let token = res.data.token;

    //         let expiredDate = new Date();
    //         expiredDate.setDate(expiredDate.getDate() + 7);
    //         let domain = window.location.hostname;
    //         this.cookieService.set('innerToken', token, expiredDate, '/', domain, false, "Lax"); 
    //         localStorage.setItem('token', token);
    //       }
          
    //     }else{

    //       if(this.cookieService.get('innerToken')) {
    //         this.cookieService.delete('innerToken');
    //       };

    //       localStorage.removeItem('token');
    //       localStorage.removeItem('currentUser');

    //       localStorage.clear();
    //     }
    //   }
    // )
  }
  
  doLogin(){
    this.authenticationService.getLogin({email: this.email, password: this.password, rememberMe: this.isRemember}).subscribe(
      (session:Session) =>{
        if (session) {
          this.router.navigate(['/quotation/main']);
        }
      }
    )
  }

  keydown(event){
    if(event.keyCode == 13){
      this.doLogin();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts